<template>
  <div class="banner-opacity">
    <div class="banner" v-for="b in banners" :class="{'active': b.active}">
      <a :href="banners.find(br => br.active).url" class="banner-link">
        <img :src="b.banner" :alt="b.name" class="banner-image" />
        <p class="banner-title">
          <span>Witamy</span>
          <span>w</span>
          <span class="gradient">vetdirect</span>
        </p>
      </a>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cms from "../../cms/src/Cms";

export default {
  props: ["delay"],
  computed: {
    ...mapState({
      bannerList: state => state.banner.list
    })
  },
  data() {
    return {
      banners: [],
      activeIndex: 0
    };
  },
  methods: {
    changeIndex() {
      this.activeIndex++;
      if (this.activeIndex >= this.banners.length) {
        this.activeIndex = 0;
      }
      for (let index in this.banners) {
        this.banners[index].active = index == this.activeIndex;
      }
      setTimeout(this.changeIndex, this.delay);
    },
    buildBanners() {
      let list = this.bannerList.map(b => {
        let obj = { ...b, active: false, bodyDecode: Cms.decode(b.body) };
        return obj;
      });
      if (list.length > 0) {
        list[0].active = true;
      }
      this.banners = list;
    }
  },

  async beforeMount() {
    await this.$store.dispatch("banner/getList", {
      width: "org",
      height: "org"
    });
    this.buildBanners();
    setTimeout(this.changeIndex, this.delay);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/banners/src/BannerOpacity.vue